// extracted by mini-css-extract-plugin
module.exports = {"container":"Login_container__3mKn7","formContainer":"Login_formContainer__q_1Lg","logo":"Login_logo__2z8vn","link":"Login_link__3kXOg","buttom":"Login_buttom__2bhPB"};